import { render } from "./demo-day-community-investor-application-modal.vue?vue&type=template&id=2d557948"
import script from "./demo-day-community-investor-application-modal.vue?vue&type=script&lang=js"
export * from "./demo-day-community-investor-application-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__